<template>
  <!-- default card -->
  <div class="card">
    <div class="row-wrapper" v-if="appList && appList.rows && appList.rows.length > 0" v-for="row in appList.rows">
      <div v-if="row.items[0]['type'] === 'widget'" class="default-card" style="margin:4px">
        <div class="default-first-row">
          <div class="default-first-left">
            <div class="default-title designer-card-text size-default" v-if="item.title">
              {{ item.title }}
            </div>
            <div class="default-title designer-card-text size-default" v-else>
              {{ "(Untitled Empty)" }}
            </div>
          </div>


          <div class="default-first-right">
            <fts-tippy :content="item.state && item.state.name" class="list-state-wrapper"
              v-if="item.state && item.state.id">
              <fts-state :state="item.state" :states="states" class="dv-list-state" />
            </fts-tippy>

            <fts-assign-to :module-id="moduleId" :form-data="item" :max-length="3" avatar-mode :toggle-due="false"
              :toggle-create="false" :view-mode="!isAssignRight" :comment-section="isCommentRight"
              class="dv-list-entry-assign stopPropagation" @refresh="refreshList"
              v-if="item.assignees && item.assignees.length" />
            <div class="dv-list-entry-comment" v-if="item.lastComment && item.lastComment.id">
              <fts-tippy :options="{ theme: 'light-border' }" :request="{
                dispatchName: 'loadHistory',
                payload: {
                  id: item.lastComment.id,
                  type: item.lastComment.type ?
                    item.lastComment.type :
                    'comment'
                },
              }" append-content-class="fts-collaboration-content">
                <div slot="trigger" class="dv-list-entry-comment-trigger"
                  :class="{ 'dv-list-entry-comment-trigger--active': (item.collaborationFlags & 4) === 4 }">
                  <font-awesome-icon :icon="['far', 'comment-alt']" />
                </div>
                <template #content="{ content, loading }">
                  <template v-if="content">
                    <div class="collaboration-comment-audit">
                      <fts-profile :userName="content.createdBy" />
                      <div class="comment-from-now">
                        {{ momentRelativeTime(content.createdDate) }}
                      </div>
                    </div>
                    <div class="collaboration-comment-content" v-html="translateCommentContent(content.detail)"></div>
                    <div class="collaboration-date">
                      {{ moment(content.createdDate).format("llll") }}
                    </div>
                  </template>
                  <fts-spinner :size="16" show v-else-if="loading" />
                </template>
              </fts-tippy>
              <div class="dv-list-entry-comment-count" v-if="item.commentCount">
                {{ item.commentCount > 99 ? 99 : item.commentCount }}
              </div>
            </div>
          </div>
        </div>
        <div class="default-second-row">
          <div class="dv-list-entry-profile" v-if="item.audit && item.audit.updatedBy">
            <fts-profile :user-name="item.audit.updatedBy" :profile-photo="false"
              profile-name-class="dv-list-entry-profile-name" />
            &nbsp;{{ " · " }}&nbsp;
            <fts-tippy :content="moment(item.audit.updatedDate).format('llll')" class="dv-list-entry-profile-date">
              <div slot="trigger">
                {{ momentRelativeTime(item.audit.updatedDate) }}
              </div>
            </fts-tippy>
          </div>
        </div>
      </div>
      <!-- image -->
      <div
        v-if="row.items[0]['type'] === 'information' && getInformationValue(row.items[0].id) && (getInformation(row.items[0].id).type === 10 || getInformation(row.items[0].id).type === 11)"
        style="margin:4px">
        <template v-if="(value = getInformationValue(row.items[0].id))">
          <fts-file class="file-upload-display" :prefixURL="`${vectorId}-${row.items[0].id}`" :data="value"
            :file-type="`image`" downloadable :image-width="getImageWidth(row.items[0])"
            :image-height="getImageHeight(row.items[0])" />
        </template>
      </div>
      <div class="desginer-card-row" :class="{
        'single-cell': row.items.length === 1,
        'two-cells': row.items.length === 2,
        'three-cells': row.items.length === 3,
      }" v-else>
        <div v-for="(cell, index) in row.items" :key="cell.id" class="desginer-card-cell"
          :class="{ 'align-right': row.items.length === 3 && index === 2 }">
          <div v-if="cell.type === 'information'">
            <template v-if="(value = getInformationValue(cell.id))">
              <!-- select -->
              <div v-if="getInformation(cell.id).type === 27 && !getInformation(cell.id).reference" style="margin:4px">
                <div class="fts-display-form-control display-dropdown">
                  <div class="fts-display-form-tag display-dropdown-tag" :class="getTextClass(cell)"
                    :style="{ 'background-color': getColor(getInformation(cell.id).optionList, value) }">
                    {{ value }}
                  </div>
                </div>
              </div>
              <!-- tags -->
              <div class="tag-row-wrapper" v-else-if="getInformation(cell.id).type === 28" style="margin:4px">
                <div v-for="v in value">
                  <div class="fts-display-form-tag display-dropdown-tag" :class="getTextClass(cell)"
                    :style="{ 'background-color': getColor(getInformation(cell.id).optionList, v) }">
                    {{ v }}
                  </div>
                </div>
              </div>
              <!-- link -->
              <div v-else-if="getInformation(cell.id).type === 33" style="margin:4px">
                <a class="fts-link-primary" target="_blank" :href="linkURL(value)">
                  <div :class="getTextClass(cell)">
                    {{ value }}
                  </div>
                </a>
              </div>
              <!-- check box -->
              <div v-else-if="getInformation(cell.id).type === 1" style="margin:4px">
                <font-awesome-icon :icon="['fas', 'check']" :style="{ 'color': 'var(--fts-primary)' }" />
              </div>
              <!-- location -->
              <div v-else-if="getInformation(cell.id).type === 9" style="margin:4px">
                <fts-tippy content="View location on Google Maps" class="contact-link-display-shortcut">
                  <a class="fts-link-primary" target="_blank"
                    :href="`http://www.google.com/maps/place/${value.lat},${value.lng}`">
                    <div :class="getTextClass(cell)">
                      {{ value.placeName }}
                    </div>
                  </a>
                </fts-tippy>
              </div>
              <!-- email -->
              <div v-else-if="getInformation(cell.id).type === 25" style="margin:4px">
                <a class="fts-link-primary" target="_blank" :href="'mailto:' + value">
                  <div :class="getTextClass(cell)">
                    {{ value }}
                  </div>
                </a>
              </div>
              <!-- phone number -->
              <div v-else-if="getInformation(cell.id).type === 26" style="margin:4px">
                <fts-tippy content="Open in WhatsApp" class="contact-link-display-shortcut">
                  <a class="fts-link-primary" target="_blank" :href="`https://wa.me/${value.replace(/\D+/g, '')}`">
                    <div :class="getTextClass(cell)">
                      {{ value }}
                    </div>
                  </a>
                </fts-tippy>
              </div>
              <!-- created by -->
              <div v-else-if="getInformation(cell.id).id === 'createdBy'" style="margin:4px">
                <fts-profile :class="getTextClass(cell)" :user-name="item.audit.createdBy" :profile-photo="false" />
              </div>
              <!-- created date -->
              <div v-else-if="getInformation(cell.id).id === 'createdDate'" style="margin:4px">
                <fts-tippy :content="moment(value).format('llll')" class="dv-list-entry-profile-date">
                  <div :class="getTextClass(cell)">
                    {{ momentRelativeTime(value) }}
                  </div>
                </fts-tippy>
              </div>
              <!-- last change by -->
              <div v-else-if="getInformation(cell.id).id === 'lastChangeBy'" style="margin:4px">
                <fts-profile :class="getTextClass(cell)" :user-name="item.audit.createdBy" :profile-photo="false" />
              </div>
              <!-- last change date -->
              <div v-else-if="getInformation(cell.id).id === 'lastChangeDate'" style="margin:4px">
                <fts-tippy :content="moment(value).format('llll')" class="dv-list-entry-profile-date">
                  <div :class="getTextClass(cell)">
                    {{ momentRelativeTime(value) }}
                  </div>
                </fts-tippy>
              </div>
              <div v-else style="margin:4px">
                <div :class="getTextClass(cell)">
                  {{ value }}
                </div>
              </div>
            </template>
          </div>
          <div v-else-if="cell.type === 'activity'" style="margin:4px">
            <template v-if="getActivity(cell.id)">
              <fts-btn class="desginer-activity-btn" outline :emoji="getActivity(cell.id).emoji"
                :color="getActivity(cell.id).color || 'primary'" @click="selectActivity(getActivity(cell.id))">
                <i :class="getActivity(cell.id).icon" v-if="getActivity(cell.id).icon"></i>
                <span class="btn-activity-label designer-card-text">
                  {{ getActivity(cell.id).name }}
                </span>
              </fts-btn>
            </template>
          </div>

        </div>
      </div>
    </div>
  </div>

</template>


<script>
import Vue from 'vue';
import numeral from 'numeral';
import moment from 'moment';
import commons from '../commons/commons';
import FTSState from './FTSState';
import FTSTippy from './FTSTippy';
import FTSAssignTo from './FTSAssignTo';
import FTSProfile from './FTSProfile';
import FTSFile from './file/FTSFile';
import FTSBtn from './FTSBtn';

export default {
  components: {
    'fts-tippy': FTSTippy,
    'fts-state': FTSState,
    'fts-assign-to': FTSAssignTo,
    'fts-profile': FTSProfile,
    "fts-file": FTSFile,
    "fts-btn": FTSBtn,
  },
  props: {
    item: Object,
    appList: Object,
    columns: Array,
    states: Array,
    activities: Array,
    vectorId: String
  },
  data: () => ({
  }),
  methods: {
    moment,
    getImageSize(item) {
      const ratio = (item.ratio || '4:3').trim();
      const orientation = (item.orientation || 'landscape').toLowerCase();
      const [w, h] = ratio.split(':').map(Number);

      if (!w || !h) return { width: 300, height: 300 }; // fallback if ratio invalid

      if (orientation === 'portrait') {
        // Portrait: width is fixed at 300, height scaled by ratio
        return {
          width: 300,
          height: Math.round((300 * w) / h)
        };
      }

      // Default: landscape
      return { width: 300, height: Math.round((300 * h) / w) };
    },
    getImageWidth(item) {
      return this.getImageSize(item).width;
    },

    getImageHeight(item) {
      return this.getImageSize(item).height;
    },
    getTextClass(cell) {
      const size = (cell.size || 'default').toLowerCase();
      const style = (cell.style || 'default').toLowerCase();

      return [
        'designer-card-text',
        `size-${size}`,
        `style-${style}`
      ];
    },
    linkURL(value) {
      return value.toLowerCase().startsWith("http") ? value : `//${value}`
    },
    momentRelativeTime(date) {
      return commons.momentRelativeTime(date);
    },
    getInformation(informationId) {
      const information = this.columns.find(information => information.id == informationId);
      return information;
    },
    getActivity(activityId) {
      const activity = this.activities.find(activity => activity.id == activityId);
      return activity;

    },
    getInformationValue(informationId) {
      const information = this.getInformation(informationId);

      if (informationId === 'documentId') {
        return this.item.documentId;
      } else if (informationId === 'createdBy') {
        return this.item.audit.createdBy;
      } else if (informationId === 'lastChangeBy') {
        return this.item.audit.updatedBy;
      } else if (informationId === 'createdDate') {
        return this.item.audit.createdDate;
      } else if (informationId === 'lastChangeDate') {
        return this.item.audit.updatedDate;
      }

      let value = this.item.extension[information.fieldName];

      if (value === null) return;

      if (information.type === 2) {
        return value.toLocaleString(undefined);
      } else if (information.type === 3) {
        if (information.customFormat) {
          return numeral(value).format(information.customFormat);
        } else if (information.displayFormat) {
          return numeral(value).format(information.displayFormat);
        } else {
          const decimalPlaces = commons.isInteger(information.decimalPlaces) ? information.decimalPlaces : 2;
          return value.toLocaleString(undefined, {
            minimumFractionDigits: decimalPlaces,
            maximumFractionDigits: decimalPlaces,
          });
        }
      } else if (information.type === 4) {
        return numeral(value).format("0,0.00");
      } if (information.type === 5 || information.type === 6) {
        const dateFormat = (format) => luxon.fromISO(value).toFormat(commons.dateFormatTranslate(format));
        if (information.enableCustomDateFormat && information.customDateFormatId) {
          return dateFormat(information.customDateFormatId);
        } else if (information.predefinedFormatId) {
          return dateFormat(information.predefinedFormatId);
        } else if (information.type === 5) {
          return dateFormat('DD');
        } else {
          return dateFormat('DD t');
        }
      } else if (this.item.type === 9) {
        // for old data
        return {
          lat: result.lat ? result.lat : result.latitude,
          lng: result.lng ? result.lng : result.longitude,
          placeName: result.placeName,
        };
      }
      return value;
    },
    getColor(optionList, text) {
      return commons.selectOptionBackground({
        optionList: optionList,
        text: text,
      });
    },
    selectActivity(activity) {
      event.stopPropagation();
      this.$emit("activity:selected", activity);
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  beforeDestroy() {
  },
}
</script>
<style scoped>
.card {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.row-wrapper {
  display: flex;
  flex-direction: column;
}


.default-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.default-first-row {
  justify-content: space-between;
  color: var(--fts-text);
  display: flex;
  
}

.default-second-row {
  display: flex;
  justify-content: start;
  color: var(--fts-default);
  font-size: small;
}

.default-first-left {
  display: flex;
  overflow:hidden;
}

.default-first-right {
  display: flex;
  gap: 4px;
  align-items: center;
  margin-top: -4px;
}

.entry-comment-count {
  font-size: smaller;
}

.assignees-row {
  position: relative;
}

.assignee-avatar {
  /* position: relative; */
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: #ccc;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  font-weight: bold;
  font-size: 10px;
  border: 0.2px solid white;
}

.state-box {
  color: #fff;
  background-color: red;
  font-size: x-small;
  font-weight: bold;
  text-align: center;
  align-content: center;
  padding: 0px 4px;
  border-radius: 0.2rem;
}

.desginer-card-row {
  display: flex;

  &.single-cell {
    justify-content: flex-start;
  }

  &.two-cells {
    justify-content: space-between;
  }

  &.three-cells {
    justify-content: flex-start;
  }
}

.desginer-card-cell {
  display: flex;
  /* max-width: 30%; */
  display: inline-block;
  /* flex: 1 1 0; */
  min-width: 0;

  &.align-right {
    margin-left: auto;
  }

}

.display-dropdown-tag {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  border-radius: 0.25rem;
  background-color: var(--fts-gray-100);
  color: var(--fts-dark);
}

.tag-row-wrapper {
  display: flex;
  gap: 4px;
}

.designer-card-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;


  &.size-s {
    font-size: 0.5rem;
  }

  &.size-l {
    font-size: 1em;
  }

  &.size-default {
    font-size: 0.875rem;
  }

  &.style-l {
    font-weight: 300;
  }

  &.style-b {
    font-weight: 700;
  }

  &.style-default {
    font-weight: 400;
  }
}

.desginer-activity-btn {
  max-width: 100%;

}
</style>
